import { useSignupData } from '../signup-data/useSignupData';
import { useView } from '../views/useView';
import { bulkEmptySignupDataAndSetFresh } from '../store/signup-data/action-creators';
import { useDispatch } from 'react-redux';
export const useSkipStep = (dataKey, stepKey) => {
  const {
    setSkipped
  } = useSignupData(dataKey);
  const {
    submit
  } = useView({
    stepKey
  });
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(bulkEmptySignupDataAndSetFresh([dataKey]));
    setSkipped();
    submit();
  };
  return {
    handleClick
  };
};